<script>
  import lodash from 'lodash';
  import TrendChart from './TrendChart.vue';
  import DataMethods from '../../utils/DataMethods.js';

  export default {
    name: 'TestsPerPhysician',
    mixins: [DataMethods],
    extends: TrendChart,
    data() {
      return {
        chartId: 'testsPerPhysician',
        fields: [
          'tests_ige',
          'tests_mqt',
          'tests_pricks',
          'tests_sticks',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        let values = {};
        lodash.each(this.curYear, (month, key) => {
          values[key] = this.calcFunction(month);
        });
        return values;
      },
      benchmarkValueRaw() {
        let values = {};
        lodash.each(this.benchmarkYear, (month, key) => {
          values[key] = this.calcFunction(month);
        });
        return values;
      },
      previousValueRaw() {
        let values = {};
        lodash.each(this.previousYear, (month, key) => {
          values[key] = this.calcFunction(month);
        });
        return values;
      },
    },
    methods: {
      calcFunction(month) {
        if (month['num_physicians_and_midlevel'] > 0) {
          return this.round(lodash.reduce(this.fields, (sum, field) => {
            return sum + parseInt(month[field])
          }, 0) / parseInt(month['num_physicians_and_midlevel']), 2);
        } else {
          return 0;
        }
      },
    },
  };
</script>
